import React from 'react';

import {
    Box,
    Stack,
    Typography,
} from '@mui/material';
import { common } from '@mui/material/colors';



export interface FooterComponentProps { }
export const FooterComponent: React.FC<FooterComponentProps> = () => {

    return (
        <Stack direction={'column'}>
            <Stack 
                width={'100%'}
                display={'flex'}
                direction={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                py={{ xs: 4, sm: 5, md: 6, lg: 7 }}
                sx={{ backgroundColor: '#003974' }}
            >
                <Typography
                    sx={{
                        fontWeight: '500',
                        color: common.white,
                        fontFamily: 'Roboto',
                        textTransform: 'capitalize',
                        fontSize: { xs: 14, sm: 16, md: 18, lg: 20 }
                    }}
                >ciputra residence</Typography>
                <Box 
                    width={64}
                    height={1.5}
                    sx={{ 
                        backgroundColor: '#ffffff',
                        mb: { sm: '1.5em', md: '1.2em', lg: '1em' },
                        mt: { sm: '0.75em', md: '0.6em', lg: '0.5em' },
                    }}
                />
                <Typography
                    sx={{
                        width: '86%',
                        fontWeight: '400',
                        textAlign: 'center',
                        fontFamily: 'Montserrat',
                        color: 'rgba(255, 255, 255, 0.5)',
                        fontSize: { xs: 10, sm: 12, md: 14, lg: 16 }
                    }}
                >
                    Ciputra Residence adalah anak perusahaan dari Grup Ciputra, salah satu pengembang properti terbesar di Indonesia dengan fokus pengembangan skala kota serta mixed-use development.
                </Typography>
            </Stack>
            <Stack 
                width={'100%'}
                display={'flex'}
                direction={'column'}
                paddingTop={'0.5em'}
                alignItems={'center'}
                paddingBottom={'0.5em'}
                justifyContent={'center'}
                sx={{backgroundColor: 'rgba(0, 128, 96, 1)'}}
            >
                <Typography
                    sx={{
                        color: 'white',
                        fontWeight: '400',
                        textAlign: 'center',
                        fontFamily: 'Montserrat',
                        textTransform: 'capitalize',
                        fontSize: { xs: 8, sm: 10, md: 12, lg: 14 }
                    }}
                >{"copyright @2023 ciputra resicende"}</Typography>
            </Stack>
        </Stack>
    )
};